import { DataAccelerationErrorCode, SiteErrorCode, CommonErrorCode } from '../../helpers/ErrorCodes';
import { IAccelerationTaskInfo } from '../../models/IAccelerationTaskInfo';
import { IErrorDetail } from '../ContentActionNotification';
import { IErrorItem } from '../../models/MultipleItemResult';
import { L10n } from '../../L10n/L10n';
import { Messages } from '../../../codegen/Localize';
import { IWorkbookBase } from '../../models/IWorkbookInfo';
import { ContentUrlForItem } from '../ContentUrl';
import { WorkbookContentType } from '../../models/ContentTypes';

function errorDetailsForTasks(accelerationTaskErrorItem: IErrorItem<IAccelerationTaskInfo>): IErrorDetail {
  return {
    itemName: accelerationTaskErrorItem.item.workbook.name,
    errorMessage: errorMessageForTasks(accelerationTaskErrorItem)
  };
}

function errorMessageForTasks(errorItem: IErrorItem<IAccelerationTaskInfo>) {
  const dataAccelerationTask = errorItem.item;
  switch (errorItem.error.code) {
    case DataAccelerationErrorCode.MATERIALIZED_VIEWS_FEATURE_DISABLED:
        return Messages.dataAccelerationFeatureDisabled();
    case DataAccelerationErrorCode.OBJECT_NOT_ENABLED:
      return Messages.dataAccelerationObjectNotEnabled({WORKBOOK_NAME: L10n.elideIfLong(dataAccelerationTask.workbook.name)});
    case DataAccelerationErrorCode.SITE_IS_NOT_ACTIVE:
      return Messages.dataAccelerationSiteIsNotActive({SITE_NAME: L10n.elideIfLong(dataAccelerationTask.site.urlName)});
    case SiteErrorCode.SITE_RUN_NOW_DISABLED:
      return Messages.siteRunNowDisabled({ SITE_NAME: L10n.elideIfLong(dataAccelerationTask.site.urlName)});
    case DataAccelerationErrorCode.WORKBOOK_HAS_NO_ACCELERATION_TASKS:
      return Messages.dataAccelerationWorkbookHasNoAccelerationTasks({WORKBOOK_NAME: L10n.elideIfLong(dataAccelerationTask.workbook.name)});
    default:
      return Messages.errorUnknown();
  }
}

function errorDetailsForWorkbooks(errorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
  return {
    itemName: errorItem.item.name,
    itemUrl: ContentUrlForItem(errorItem.item, WorkbookContentType),
    errorMessage: errorMessageForWorkbooks(errorItem)
  };
}

function errorMessageForWorkbooks(errorItem: IErrorItem<IWorkbookBase>): string {
  switch(errorItem.error.code) {
    case DataAccelerationErrorCode.ENCRYPTED_EXTRACTS_NOT_SUPPORTED:
      return Messages.dataAccelerationEncryptedExtracts();
    case DataAccelerationErrorCode.MATERIALIZED_VIEWS_FEATURE_DISABLED:
      return Messages.dataAccelerationFeatureDisabled();
    case DataAccelerationErrorCode.MISSING_CREDENTIALS:
      return Messages.dataAccelerationMissingCredential();
    case DataAccelerationErrorCode.SITE_IS_NOT_ENABLED_FOR_MATERIALIZED_VIEWS:
      return Messages.dataAccelerationSiteDisabled();
    case DataAccelerationErrorCode.WORKBOOK_HAS_NO_EMBEDDED_EXTRACTS:
      return Messages.dataAccelerationNoEmbeddedExtracts();
    case DataAccelerationErrorCode.WORKBOOK_NOT_FOUND:
      return Messages.dataAccelerationWorkbookNotFound();
    case DataAccelerationErrorCode.WORKBOOK_TOO_LARGE_TO_MATERIALIZE:
      return Messages.dataAccelerationWorkbookTooLarge();
    case CommonErrorCode.CallingUserInsufficientPermissions:
      return Messages.dataAccelerationUserNotPermitted();
  }
  return Messages.errorUnknown();
}

export const DataAccelerationErrors = {
  errorDetailsForTasks,
  errorMessageForTasks,
  errorDetailsForWorkbooks,
  errorMessageForWorkbooks
};

export type DataAccelerationErrors = typeof DataAccelerationErrors;